// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"PageLayout_contentContainer__2pBtf"};